import axios from 'utils/axiosInstance'

const BASE_URL_ENDPOINT = '/periodo_peraca/peraca'

const getPeracas = async (busqueda = '') => {
  const response = await axios.get(`${BASE_URL_ENDPOINT}/?search=${busqueda}`)
  return response.data
}

const crearPeraca = async (values) => {
  const { data, onSuccess: onSuccessMessage } = await axios.post(
    `${BASE_URL_ENDPOINT}/`,
    values,
  )
  return { data, onSuccessMessage }
}

const eliminarPeraca = async ({ id, nombre }) => {
  const { onSuccess: onSuccessMessage } = await axios.delete(
    `${BASE_URL_ENDPOINT}/${id}`,
  )
  return { data: nombre, onSuccessMessage }
}

const actualizarPeraca = async ({ id, values }) => {
  const { data, onSuccess: onSuccessMessage } = await axios.put(
    `${BASE_URL_ENDPOINT}/${id}/`,
    values,
  )
  return { data, onSuccessMessage }
}

export {
  getPeracas,
  crearPeraca,
  eliminarPeraca,
  actualizarPeraca,
}